"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { HttpClient, HttpParams, } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Auth } from '@shared/auth';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { DATASTORE_CONFIG } from './datastore.config';
import { backend, } from './backend';
import { isDefined } from './helpers';
var ApiHttp = (function () {
    function ApiHttp(http, auth, datastoreConfig) {
        this.http = http;
        this.auth = auth;
        this.datastoreConfig = datastoreConfig;
        this._requestStream = new Subject();
    }
    Object.defineProperty(ApiHttp.prototype, "requestStream", {
        get: function () {
            return this._requestStream.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    ApiHttp.prototype.fetch = function (ref) {
        var _this = this;
        return Observable.of(ref)
            .switchMap(function (_a) {
            var pathList = _a.pathList, query = _a.query;
            return Observable.of(backend[pathList[0]].fetch)
                .filter(isDefined)
                .map(function (fetch) { return ({
                newConfig: fetch(pathList[1], query),
                pagination: {
                    limit: query && query.limit,
                    offset: query && query.offset,
                },
            }); });
        })
            .withLatestFrom(this.auth.getAuthorizationHeader())
            .switchMap(function (_a) {
            var _b = _a[0], newConfig = _b.newConfig, pagination = _b.pagination, authHeader = _a[1];
            var baseUrl = newConfig.isGaf
                ? _this.datastoreConfig.ajaxBaseUrl
                : _this.datastoreConfig.apiBaseUrl;
            var params = pagination
                ? __assign({}, newConfig.params, { limit: pagination.limit, offset: pagination.offset }) : newConfig.params;
            return _this.http.get(baseUrl + "/" + newConfig.endpoint, {
                headers: authHeader,
                params: _this.serialize(params),
            });
        })
            .do(function () { return _this._requestStream.next(ref); })
            .catch(function (err) {
            if (err.error instanceof Error) {
                // A client-side or network error occurred.
                return Observable.throw(err.error);
            }
            // The backend returned an unsuccessful response code.
            return Observable.throw(new Error(err.message));
        });
    };
    ApiHttp.prototype.post = function (config, payload) {
        return this.mutate(config, { action: 'post', payload: payload });
    };
    ApiHttp.prototype.put = function (config, payload) {
        return this.mutate(config, { action: 'put', payload: payload });
    };
    ApiHttp.prototype.delete = function (config) {
        return this.mutate(config, { action: 'delete' });
    };
    ApiHttp.prototype.mutate = function (config, data) {
        var _this = this;
        return Observable.of(config)
            .withLatestFrom(this.auth.getAuthorizationHeader())
            .switchMap(function (_a) {
            var newConfig = _a[0], authHeader = _a[1];
            var baseUrl = newConfig.isGaf
                ? _this.datastoreConfig.ajaxBaseUrl
                : _this.datastoreConfig.apiBaseUrl;
            var url = baseUrl + "/" + newConfig.endpoint;
            var options = { headers: authHeader };
            if (data.action === 'delete') {
                return _this.http.delete(url, options);
            }
            var body = _this.serialize(__assign({}, data.payload, newConfig.params));
            if (data.action === 'post') {
                return _this.http.post(url, body, options);
            }
            return _this.http.put(url, body, options);
        });
    };
    ApiHttp.prototype.serialize = function (obj) {
        var params = new HttpParams();
        Object.entries(obj).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            if (typeof value === 'string') {
                params = params.set(key, value);
            }
            else if (typeof value === 'number') {
                params = params.set(key, String(value));
            }
            else if (Array.isArray(value)) {
                // This type casting shouldn't be necessary but is because of a TS bug.
                // https://github.com/Microsoft/TypeScript/issues/15315
                // https://github.com/Microsoft/TypeScript/issues/7294
                // Our backend expects arrays foo=[1,2] to be encoded as foo[]=1&foo[]=2
                value.forEach(function (rawVal) {
                    // The batching of requests connatenates things with `&`.
                    return String(rawVal)
                        .split('&')
                        .forEach(function (v) { return (params = params.append(key + "[]", v)); });
                });
            }
        });
        params = params.set('compact', 'true');
        return params;
    };
    ApiHttp = __decorate([
        Injectable(),
        __param(2, Inject(DATASTORE_CONFIG)),
        __metadata("design:paramtypes", [HttpClient,
            Auth, Object])
    ], ApiHttp);
    return ApiHttp;
}());
export { ApiHttp };



// WEBPACK FOOTER //
// api-http.service.js